module.exports = __webpack_public_path__ + "static/media/ic1dX3kBQjGNaPQb8Xel_1920x1280.82bd7d6f.jpg";